import {
  GridColumnConfig,
  GridColumnType,
  GridActionConfig,
  GridActionType,
  ToolbarButton,
  GridConfig,
} from '../../../../shared/components/kendo/grid';
import { FilterFieldConfig } from '../../../../shared/components/kendo/grid/components/grid-filter/grid-filter.component';
import { TEMPLATE_CONSTANTS } from './template-constants';

export const TEMPLATE_GRID_COLUMNS: GridColumnConfig[] = [
  {
    field: 'filename',
    title: 'Name',
    width: 180,
    filterable: true,
    sortable: true,
    type: GridColumnType.TEXT,
  },
  {
    field: 'syncstr',
    title: 'Date',
    width: 100,
    filterable: true,
    sortable: true,
    type: GridColumnType.TEXT,
  },
];

export const getTemplatesToolbarButtons = (
  handlers: {
    onUpload: () => void;
    onAddFolder: () => void;
  },
  canAdd: boolean = true
): ToolbarButton[] => {
  const buttons: ToolbarButton[] = [
    {
      id: 'upload',
      text: 'Upload Template',
      icon: 'bi bi-upload',
      tooltip: 'Upload Template',
      className: 'btn-outline-secondary',
      handler: handlers.onUpload,
    },
  ];

  buttons.push({
    id: 'add',
    text: 'Add Folder',
    icon: 'bi bi-plus-circle',
    className: 'btn-primary',
    tooltip: 'Add Folder',
    handler: handlers.onAddFolder,
  });

  return buttons;
};

export const getTemplateActions = (handlers: {
  onDownload: (item: any) => void;
  onEdit: (item: any) => void;
  onSignature: (item: any) => void;
}): GridActionConfig[] => {
  const actions: GridActionConfig[] = [
    {
      id: 'template-download',
      type: GridActionType.VIEW,
      text: 'Download',
      icon: 'bi bi-download', // ✔ Download icon
      handler: handlers.onDownload,
      visible: () => true,
    },
    {
      id: 'template-edit',
      type: GridActionType.EDIT,
      text: 'Edit',
      icon: 'bi bi-pencil-square', // ✔ Better edit icon
      handler: handlers.onEdit,
      visible: () => true,
    },
    {
      id: 'template-signature',
      type: GridActionType.VIEW,
      text: 'Signature',
      icon: 'bi bi-pencil', // ✔ Signature-like (writing)
      handler: handlers.onSignature,
      visible: (item) => item['isTemplateSignature'],
    },
  ];
  return actions;
};

export const createTemplateGridConfig = (
  actions: GridActionConfig[],
  toolbarButtons: ToolbarButton[]
): GridConfig => ({
  columns: [
    ...TEMPLATE_GRID_COLUMNS,
    {
      field: 'actions',
      title: 'Actions',
      width: 120,
      filterable: false,
      sortable: false,
      type: GridColumnType.ACTIONS,
      actions: actions,
    },
  ],
  toolbarButtons: toolbarButtons,
  showSearch: true,
  pageable: {
    enabled: true,
    pageSize: TEMPLATE_CONSTANTS.DEFAULT_PAGE_SIZE,
    pageSizes: TEMPLATE_CONSTANTS.PAGE_SIZE_OPTIONS,
    showPageSizeSelector: true,
    showTotalCount: true,
    buttonCount: TEMPLATE_CONSTANTS.BUTTON_COUNT,
    previousNext: true,
    responsive: true,
  },
  sortable: {
    enabled: true,
    allowUnsort: true,
    mode: 'single' as any,
  },
  filterable: {
    enabled: true,
    mode: 'menu' as any,
  },
  groupable: {
    enabled: false,
  },
  selectable: {
    enabled: false,
  },
  resizable: true,
  reorderable: true,
});

export const INITIAL_GRID_STATE = {
  skip: 0,
  take: TEMPLATE_CONSTANTS.DEFAULT_PAGE_SIZE,
  sort: [],
  filter: undefined,
  search: '',
};

export const TEMPLATE_PORTLET_CONFIG = TEMPLATE_CONSTANTS.PORTLET_CONFIG;

export const TEMPLATE_FILTER_FIELDS: FilterFieldConfig[] = [
  {
    id: 'search',
    controlType: 'input',
    formControlName: 'search',
    config: {
      label: '',
      placeholder: 'Search template...',
      type: 'text',
      icon: 'bi bi-search',
    },
    width: '250px',
    className: 'filter-field search-control',
    applyTo: ['filename'],
    operator: 'contains',
    logic: 'or',
    debounceTime: 500,
    gridPosition: { colSpan: 3 },
  },
];
